import React, { useState, forwardRef, useEffect } from 'react';

import './ImageRotateViewer.scss';

const ImageRotateViewer = forwardRef(({ className, file, rotate, src }, ref) => {
  const [imageSrc, setImageSrc] = useState('');

  const applyFilter = () => {
    const canvas = ref.current;
    const context = canvas?.getContext('2d');
    const fileReader = new FileReader();

    fileReader.onload = () => {
      const image = new Image();

      image.onload = () => {
        if (canvas && context) {
          canvas.width = image.width;
          canvas.height = image.height;
          context.save();
          if (rotate) {
            const centerX = canvas.width / 2;
            const centerY = canvas.height / 2;
            context.translate(centerX, centerY);
            context.rotate((rotate * Math.PI) / 180);
            context.translate(-centerX, -centerY);
          }
          context.drawImage(image, 0, 0, canvas.width, canvas.height);

          context.restore();
        }
      };

      image.src = fileReader.result;
      if (window.location.protocol.includes('http:')) image.crossOrigin = 'anonymous';
    };
    fileReader.readAsDataURL(file);
  };

  useEffect(() => {
    setImageSrc(src);
  }, [src]);

  useEffect(() => {
    if (file) {
      const fileSrc = URL.createObjectURL(file);
      setImageSrc(fileSrc);
      return () => {
        URL.revokeObjectURL(fileSrc);
      };
    }
  }, [file]);

  useEffect(() => {
    applyFilter();
  }, [file, imageSrc, rotate]);

  if (rotate) {
    return <canvas id="canvas" ref={ref} />;
  }

  return <img className={className} src={imageSrc} alt="No Thumbnail" />;
});

export default ImageRotateViewer;
